<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/120zwWm/tc-custom/9781488021831.jpg?1705346002140" alt="This image is the cover for the book Pregnant Courtesan for the Rake, The Society of Wicked Gentlemen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pregnant Courtesan for the Rake, The Society of Wicked Gentlemen
      </h1>
      <p class="bookDescription body article font2">
        <b>A passionate encounter in Paris leads a rake to reform his ways in this Regency romance of forbidden desire and secret identities.</b><br/><br/>It’s been more than three months, but Oliver Gregory still remembers the exquisite night he shared with a beautiful woman in Paris. Discovering her working at the discreet London gentlemen’s club he owns comes as a shock . . . even more so when he realizes she’s pregnant!<br/><br/>Oliver knows the pain of being an outcast. And he will do all in his power to ensure his child is not born illegitimate. Cecilia will return to his bed . . . as his wife!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diane Gaston
      </h2>
      
      <p class="authorDescription body article">Diane Gaston&#39;s dream job had always been to write romance novels. One day she dared to pursue that dream and has never looked back. Her books have won Romance&#39;s highest honours: the RITA Award, the National Readers Choice Award, Holt Medallion, and Golden Heart. She lives in Virginia with her husband and three very ordinary house cats. Diane loves to hear from readers and friends. Visit her website at:&#160;<a href="http://dianegaston.com">https://www.dianegaston.com/</a></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?82020f48